import { useEffect, useId, useState } from 'react';
import classes from './checkbox.module.css';

/**
 * @param {object} props
 * @param {boolean} [props.value]
 * @param {string} [props.label]
 * @param {(value: boolean) => void} [props.valueChange]
 * @returns {React.JSX.Element}
 */
export function Checkbox({ value, label, valueChange }) {
  const labelId = useId();
  const [isChecked, setIsChecked] = useState(Boolean(value));

  const toggleChecked = () => {
    const newIsChecked = !isChecked;
    setIsChecked(newIsChecked);
    valueChange?.(newIsChecked);
  };

  const handleKeyUp = (/** @type {React.KeyboardEvent} */ event) => {
    if (event.code === 'Space' || event.key === 'Space') {
      toggleChecked();
    }
  };

  const handleClick = (/** @type {React.UIEvent} */ event) => {
    event.preventDefault();
    toggleChecked();
  };

  useEffect(() => {
    setIsChecked(Boolean(value));
  }, [value]);

  return (
    <div
      role="checkbox"
      className={classes.checkbox}
      aria-checked={isChecked}
      aria-labelledby={labelId}
      onKeyUp={handleKeyUp}
      onClick={handleClick}
    >
      <div className={classes.checkboxIcon} tabIndex={0}>
        <svg width="16" height="16" viewBox="0 0 16 16">
          <path
            d="M13.772 4.90234L6.3501 12.3242L2.22803 8.20215L3.4624 6.96777L5.93604 9.44141L6.3501 9.85645L6.76416
              9.44141L12.5376 3.66797L13.772 4.90234Z"
          />
        </svg>
      </div>
      <label id={labelId}>{label}</label>
    </div>
  );
}
